import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { verifyNewBankCard } from 'services/bankManagements'
import posthog from 'posthog-js'
import useGoBack from 'utilities/navigation/back'

interface IOptions {
    /**
     * Called instead of leaving the page — for a form embedded in a flow (the
     * payout account picker) that has to stay exactly where it is.
     */
    onVerified?: (bankAccountId: number) => void
    /** Where the account was added from, for the analytics event. */
    source?: string
}

export default function useSetVerifiedCard({
    onVerified,
    source = 'bank_cards_page',
}: IOptions = {}) {
    // a bare navigate(-1) walked a member who had landed straight on the add
    // page (a mini-app launch, a reload) out of Hamyan altogether
    const goBack = useGoBack('/manage-bank-cards')
    const { isLoading, mutate, data } = useMutation({
        mutationFn: (cardNumber: number) => {
            return verifyNewBankCard(cardNumber)
        },
        onSuccess: (_, variables) => {
            toast.success('کارت با موفقیت ثبت شد')
            posthog.capture('bank_account_added', {
                bank_account_id: variables as any,
                source,
            })
            if (onVerified) {
                onVerified(variables)
                return
            }
            goBack()
        },
        onError: () => {
            posthog.capture('bank_account_add_failed', { source })
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutateVerify: mutate, data }
}
